import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import { ProductCard } from "@/components/ProductCard";
import { Reveal } from "@/components/Reveal";

const SPANS_REMOVED = null;

export const FeaturedGrid = () => {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    api.get("/products", { params: { featured: true } }).then((r) => setProducts(r.data)).catch(() => {});
  }, []);

  return (
    <section id="featured" data-testid="featured-section" className="mx-auto max-w-[1600px] px-6 py-24 sm:px-10 sm:py-32">
      <Reveal>
        <div className="mb-16 flex flex-wrap items-end justify-between gap-6">
          <div>
            <p className="mb-4 text-xs uppercase tracking-[0.3em] text-taupe">This season</p>
            <h2 className="font-serif text-3xl font-light tracking-tight sm:text-4xl lg:text-5xl">
              The pieces people<br />write to us about
            </h2>
          </div>
          <Link
            to="/shop"
            data-testid="featured-view-all"
            className="group flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-ash transition-colors duration-300 hover:text-charcoal"
          >
            View everything
            <ArrowRight size={14} className="transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </div>
      </Reveal>
      <div className="grid grid-cols-2 gap-6 md:grid-cols-3 md:gap-10">
        {products.slice(0, 6).map((p, i) => (
          <Reveal key={p.slug} delay={i * 0.06}>
            <ProductCard product={p} ratio="aspect-[4/5]" />
          </Reveal>
        ))}
      </div>
    </section>
  );
};
